import JobDescriptionCard from "./JobDescriptionCard";

export default JobDescriptionCard;
